import { MicrositeComponentCtx } from "@/context/MicrositeComponent";
import { useContext } from "react";
import { useMicrositeCtx } from "./useMicrositeCtx";

export const useMicrositeComponent = () => {
  const { id, index } = useContext(MicrositeComponentCtx);
  const ctx = useMicrositeCtx();
  return {
    id,
    index,
    ctx,
    watch: (key: string, defaultValue?: any) =>
      //@ts-ignore
      ctx.watch(`data.components.${index}.${key}`, defaultValue) as any,
    set: (key, value) => {
      //@ts-ignore
      ctx.setValue(`data.components.${index}.${key}`, value);
    },
  };
};

export const useComponent = () => {
  return {
    focusTo: (id: string) => {
      window.parent.postMessage(
        {
          from: "microsite_preview",
          action: "FOCUS",
          data: {
            id,
          },
        },
        "*"
      );
    },
  };
};
